import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import './HealthNavigationPage.css';

import { routePaths } from 'services/routing';
import { useDispatch, useSelector } from 'react-redux';

import { Header, BackAction, BottomNavigation } from 'shared';
import ProfileSwitcher from 'profiles/page/ProfileSwitcher.jsx';
import { DataLoadingStatus } from 'shared';
import LoadingPage from 'shared/loading/LoadingPage';

import { fetchEpicDocuments } from './epicDocumentSlice';

export default function HealthNavigationPage() {

    const [expandedTables, setExpandedTables] = useState({});
    const hasFetchedRef = useRef(false);

    const dispatch = useDispatch();

    const { dataType: rawDataType } = useParams();

    const { xmlSections, loading, error } = useSelector(
        state => state.epicDocuments
    );

    const accessToken = localStorage.getItem("epicAccessToken");
    const patientId = localStorage.getItem("epicPatientId");


    const extractDatesFromTable = (htmlString) => {

        if (!htmlString) return [];

        const dateRegex = /\b(?:\d{1,2}[-\/\.]\d{1,2}[-\/\.]\d{2,4}|[A-Za-z]{3}[-\/\.]\d{1,2}[-\/\.]\d{4})\b/g;

        const matches = htmlString.match(dateRegex) || [];

        const allDates = matches
            .map(date => new Date(date))
            .filter(d => !isNaN(d));

        if (!allDates.length) return [];

        const latest = allDates.sort((a, b) => b - a)[0];

        return [latest.toLocaleDateString('en-US')];

    };


    useEffect(() => {

        const hasData =
            xmlSections &&
            Object.keys(xmlSections).length > 0;

        console.log("Has existing data:", hasData);

        if (!hasFetchedRef.current && accessToken && patientId && !hasData) {

            console.log("📡 Fetching Epic documents...");

            hasFetchedRef.current = true;

            dispatch(
                fetchEpicDocuments(
                    patientId,
                    accessToken
                )
            );
        } else {
            console.log("Using cached Redux data");
        }

    }, [dispatch, accessToken, patientId, xmlSections]);



    useEffect(() => {

        if (xmlSections && xmlSections[rawDataType]) {

            const records = xmlSections[rawDataType];

            const initialExpandedState = {};

            records.forEach((_, index) => {
                initialExpandedState[index] = index === 0;
            });

            setExpandedTables(initialExpandedState);

        }

    }, [xmlSections, rawDataType]);

    const handleTableToggle = (index) => {

        setExpandedTables(prev => ({
            ...prev,
            [index]: !prev[index]
        }));

    };



    const renderTable = () => {

        let records = xmlSections?.[rawDataType];

        if (!records || records.length === 0) {
            return (
                <div className='record-error'>
                    No data available for "{rawDataType}"
                </div>
            );
        }

        records = records.map(entry => ({
            ...entry,
            extractedDates: extractDatesFromTable(entry.table)
        }));

        records.sort((a, b) => {

            const dateA = new Date(a.extractedDates[0]);
            const dateB = new Date(b.extractedDates[0]);

            return dateB - dateA;

        });

        return records.map((entry, index) => (

            <div
                key={index}
                className='ehr_container'
                style={{
                    marginBottom: '20px',
                    border: "1px solid gainsboro",
                    padding: "10px 5px",
                    borderRadius: "5px"
                }}
            >

                <div
                    className='ehr-heading'
                    onClick={() => handleTableToggle(index)}
                >

                    <div className='org-name'>
                        {entry?.title}
                    </div>

                    {entry.extractedDates.length > 0 && (
                        <div style={{ fontSize: '14px', color: '#555' }}>
                            {entry.extractedDates}
                        </div>
                    )}

                    <div
                        className='view-close-button'
                        style={{
                            color: expandedTables[index] ? 'red' : 'blue'
                        }}
                    >
                        {expandedTables[index] ? 'Close' : 'View'}
                    </div>

                </div>

                {expandedTables[index] && (

                    <div
                        className='ehr-table'
                        dangerouslySetInnerHTML={{ __html: entry?.table }}
                    />

                )}

            </div>

        ));

    };

    /* =============================
       LOADING
    ============================= */

    if (loading) return <LoadingPage />;

    /* =============================
       ERROR
    ============================= */

    if (error) {

        return (
            <div className='error-page'>

                <Header
                    farLeftElement={<BackAction to={routePaths.electronicHealthRecord} />}
                    centerElement={<p>Electronic Health Record</p>}
                    leftElement={<ProfileSwitcher readonly={false} />}
                />

                <div className='record-error'>
                    No Information Available
                </div>

            </div>
        );

    }

    /* =============================
       UI
    ============================= */

    return (

        <div className="Detail_container">

            <Header
                farLeftElement={<BackAction to={routePaths.electronicHealthRecord} />}
                centerElement={<p>{rawDataType}</p>}
                leftElement={<ProfileSwitcher readonly={false} />}
            />

            <main id="mainContentContainer" style={{ padding: '20px' }}>

                <DataLoadingStatus loading={loading} error={error} overlay>
                    {renderTable()}
                </DataLoadingStatus>

            </main>

            <BottomNavigation />

        </div>

    );

}
